import React from 'react';

import { Badge } from 'components/Badge';
import { STATUS_COLOR_MAP } from 'scenes/FinancePage/SA/constants';

interface StatusConfig {
  value: { id: number; name: string };
  slot?: 'start' | 'end';
}

const Status: React.FC<StatusConfig> = ({ value, children, ...props }) => {
  const color = STATUS_COLOR_MAP.get(value?.id);
  return (
    <Badge color={color} {...props}>
      {value?.name}
    </Badge>
  );
};

export default Status;
